"use client";

import React from "react";
import { GoogleTagManager } from "@next/third-parties/google";
import DatadogInit from "@/services/Datadog/datadog-init";
import AlertConsoleLog from "@/utils/AlertConsoleLog";
import { Head } from "./Head";
import Utms from "@/utils/UTM";
import CookiePolicy from "@/components/atoms/CookiePolicy/cookiePolicy";
import { AmplitudeContextProvider } from "@/contexts/Amplitude";
import { GlobalProvider } from "@/contexts/SiteDataContext";
import { useGetSiteFont } from "@/hooks/useGetSiteFont";
import { getSiteHasExperiments } from "./helpers";
import { LayoutCleanProps } from "./types";
import "../styles/_base.scss";

export const LayoutClean = ({
  children,
  language,
  configData,
  siteDataFromApi,
  siteDataComplete,
  t,
  host,
  hideCookiePolicy = false,
}: LayoutCleanProps) => {
  const siteHasGtm = typeof siteDataFromApi === "object" && siteDataFromApi && siteDataFromApi.gtm;
  const siteFont = useGetSiteFont(configData.web_fontFamily);
  const siteTheme =
    typeof siteDataFromApi === "object" && siteDataFromApi !== null && "theme" in siteDataFromApi
      ? siteDataFromApi.theme
      : "classic";
  const siteHasExperiments = getSiteHasExperiments(siteDataFromApi);

  return (
    <html
      lang={language}
      data-scroll-behavior="smooth">
      <Head
        siteTheme={siteTheme}
        siteHasExperiments={siteHasExperiments}
        host={host}
      />
      <body className={siteFont}>
        <DatadogInit />
        <Utms />
        {siteHasGtm && <GoogleTagManager gtmId={siteDataFromApi.gtm} />}
        <AlertConsoleLog />
        <GlobalProvider
          siteDatafromProps={siteDataFromApi}
          configDataFromProps={configData}
          siteDataCompleteFromProps={siteDataComplete}
          t={t}
          language={language}>
          <AmplitudeContextProvider>
            {!hideCookiePolicy && <CookiePolicy t={t} />}
            {children}
          </AmplitudeContextProvider>
        </GlobalProvider>
      </body>
    </html>
  );
};

export default LayoutClean;
